<template>
    <EChart
        card
        :header="$t('overview')"
        :loading="loading"
        :error="error"
        type="bar"
        height="380"
        :options="echartOptions"
    />
</template>

<script>
    import clone from 'lodash/clone';
    import EChart from '@/components/common/EChart.vue';
    import { generateChartData, chartDataGroupBy } from '@/utils/chart';

    export default {
        name: 'TipsChart',
        inject: {
            parentComponent: { default: null },
        },
        components: { EChart },
        data() {
            return {
                options: {
                    yaxis: {
                        labels: {
                            show: false,
                            formatter: val => this.$format.currency(val),
                        },
                    },
                },
                rawData: [],
                currentFilters: {},
            };
        },
        computed: {
            filters() {
                return this.parentComponent.filters;
            },
            filtersParams() {
                const f = this.filters;
                const params = {
                    startDate: f.timeRange?.startDate,
                    endDate: f.timeRange?.endDate,
                    groupBy: this.groupBy,
                };
                if (f.statuses?.length) params.statuses = f.statuses.join(',');
                if (f.space) params.spaces = f.space.value;
                if (f.users?.length) params.users = f.users.map(u => u.id).join(',');
                return params;
            },
            loading() {
                return this.$store.getters['tipTransactions/getLoading']('chart');
            },
            error() {
                return this.$store.getters['tipTransactions/getError']('chart');
            },
            chartData() {
                return this.$store.getters['tipTransactions/getChart'];
            },
            groupBy() {
                return chartDataGroupBy(this.filters.timeRange);
            },

            echartOptions() {
                const labels = this.rawData.map(pt => this.$format.date(Number(pt.x), 'dd MMM yyyy'));
                const values = this.rawData.map(pt => pt.y);

                return {
                    legend: { show: false },
                    tooltip: {
                        trigger: 'axis',
                        axisPointer: { type: 'shadow' },
                        formatter: params => {
                            const item = Array.isArray(params) ? params[0] : params;
                            return this.$format.currency(item.value);
                        },
                    },
                    xAxis: {
                        type: 'category',
                        data: labels,
                    },
                    yAxis: {
                        type: 'value',
                        ...this.options.yaxis,
                    },
                    series: [
                        {
                            type: 'bar',
                            data: values,
                            itemStyle: {
                                color: '#2e93fa',
                            },
                        },
                    ],
                };
            },
        },
        watch: {
            'filters.timeRange': {
                immediate: true,
                handler(newVal, oldVal) {
                    if (JSON.stringify(newVal) !== JSON.stringify(oldVal)) {
                        this.fetchData();
                    }
                },
            },
            chartData: {
                immediate: true,
                handler(data) {
                    this.rawData = generateChartData(
                        this.filters.timeRange,
                        data.map(item => [item.date, item.amount]),
                        this.groupBy
                    );
                },
            },
        },
        methods: {
            clearData() {
                this.$store.commit('tipTransactions/clearChart');
            },
            fetchData() {
                this.currentFilters = clone(this.filtersParams);
                this.$store.dispatch('tipTransactions/fetchChart', { requestParams: this.filtersParams }).catch(this.clearData);
            },
        },
        mounted() {
            this.clearData();
        },
    };
</script>
